// Calculate timestamp for day before
export function getTimeByDayBefore(nowTime: Date, days: number) {
  const searchTimeStart = new Date(nowTime.getTime() - (days * 24 * 60 * 60 * 1000));
  return searchTimeStart.getTime();
}

